/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.1
 * @since 1.20.1
 */

import { EBasketType } from '../../modules/app/appConstants';
import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
import { IWizardRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export const WizardBillsDocRouteConfiguration: IWizardRouterConfiguration[] = [
    {
        basketType: EBasketType.BILLS,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.bills,
            EBreadCrumbType.billsDoc,
        ],
        path: RoutePath.wizardBillsDocs,
    },
    {
        basketType: EBasketType.BILLS_ACCOUNT,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.billsAccountId,
            EBreadCrumbType.billsDoc,
        ],
        path: RoutePath.wizardBillsDocsAccount,
    },
    {
        basketType: EBasketType.BILLS_UNPAID,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.billsUnpaid,
            EBreadCrumbType.billsDoc,
        ],
        path: RoutePath.wizardBillsDocsUnpaid,
    },
    {
        basketType: EBasketType.BILLS_UNPAID_ACCOUNT,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.billsUnpaidAccountId,
            EBreadCrumbType.billsDoc,
        ],
        path: RoutePath.wizardBillsDocsUnpaidAccount,
    },
];
